@if (captionList.length) {
  <div class="captions-container" [ngClass]="{ 'mingle-mode-container': !presentationMode }">
    <div class="caption-wrapper">
      @for (captionItem of captionList; track captionItem) {
        <div class="caption-item">
          <div class="profile-picture-container">
            <profile-picture
              data-testid="profile-picture-cc"
              [size]="30"
              [user]="captionItem.user"
              [borderWidth]="'0'"
            ></profile-picture>
          </div>
          <div class="caption-item-container">
            <div class="name-wrapper">
              <span class="caption-name" [ngClass]="{ 'mingle-mode-caption-name': !presentationMode }">{{
                formatName(captionItem.user.firstName, captionItem.user.lastName)
              }}</span>
            </div>
            <span class="caption-text" [ngClass]="{ 'mingle-mode-caption-text': !presentationMode }">{{
              captionItem.text
            }}</span>
          </div>
        </div>
      }
    </div>
  </div>
}
